import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, MenuItem, Select, FormControl, InputLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Grid, Box, TextField } from '@mui/material';
import axios from 'axios';

const apiUrl = 'https://api.academy.eurekagroup.id/certificates';

const CertificatePage = () => {
  const [data, setData] = useState([]);
  const [employeeFilter, setEmployeeFilter] = useState('');
  const [certificateFilter, setCertificateFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Fetch certificate data
  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        const response = await axios.get(apiUrl);
        console.log(response.data); // Inspect the API response

        // Set the fetched data to state directly
        setData(response.data); 
      } catch (error) {
        console.error('Error fetching certificate data:', error);
      }
    };
  
    fetchCertificates();
  }, []);  

  const handleEmployeeFilterChange = (event) => {
    setEmployeeFilter(event.target.value);
  };

  const handleCertificateFilterChange = (event) => {
    setCertificateFilter(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Filter certificates based on employeeName and certificates fields
  const filteredData = data.filter((certificate) =>
    (employeeFilter ? certificate.id_employee.full_name?.toLowerCase() === employeeFilter.toLowerCase() : true) &&
    (certificateFilter ? certificate.id_course.title_course?.toLowerCase() === certificateFilter.toLowerCase() : true) &&
    (certificate.id_employee.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      certificate.id_course.title_course?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Generate lists for employeeNames and certificate titles for dropdowns
  const employeeNames = Array.from(new Set(data.map((certificate) => certificate.id_employee.full_name)));
  const certificateTypes = Array.from(new Set(data.map((certificate) => certificate.id_course.title_course)));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="Certificate Management"
            action={
              <Box display="flex" gap={2}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    sx={{
                      fontSize: '1rem', // Adjust the label font size if needed
                      whiteSpace: 'nowrap', // Prevent wrapping of the label text
                      overflow: 'visible', // Make sure the text is visible
                      textOverflow: 'clip', // Remove ellipsis if the text is too long
                    }}
                  >
                    Employee Name
                  </InputLabel>
                  <Select
                    value={employeeFilter}
                    onChange={handleEmployeeFilterChange}
                    label="Employee Name"
                    sx={{ width: 'auto', minWidth: 200 }} // Allow the box to grow automatically and ensure minimum width
                  >
                    <MenuItem value="">All</MenuItem>
                    {employeeNames.map((name, index) => (
                      <MenuItem key={index} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Certificate</InputLabel>
                  <Select
                    value={certificateFilter}
                    onChange={handleCertificateFilterChange}
                    label="Certificate"
                    sx={{ width: 'auto', minWidth: 200 }} // Same approach for this select box
                  >
                    <MenuItem value="">All</MenuItem>
                    {certificateTypes.map((certificate, index) => (
                      <MenuItem key={index} value={certificate}>
                        {certificate}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            }
          />
          <CardContent>
            <Box mb={2}>
              <TextField
                label="Search"
                variant="outlined"
                fullWidth
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>No</TableCell>
                    <TableCell>Employee Name</TableCell>
                    <TableCell>Certificate</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.length > 0 ? (
                    filteredData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((certificate, index) => (
                        <TableRow key={certificate._id || index}>  {/* Fallback key */}
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell>{certificate.id_employee.full_name || 'Unknown'}</TableCell>
                          <TableCell>{certificate.id_course.title_course || 'N/A'}</TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3}>No certificates found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CertificatePage;
